<template>
  <div>
    <div class="content">
      <!--      <div class="content-main">-->
      <!--        <p class="content-title">后台目录</p>-->
      <!--      </div>-->
      <div class="content-main">
        <p class="content-title" style="padding-bottom: 16px;">后台目录</p>
        <div class="content-button">
          <div style="display: flex; align-items: center;">
            <el-button type="primary" @click="callDialog('添加1级模块', {level: 1, pre_id: 0 }, { id: 0 })" size="default">添加1级模块</el-button>
            <el-input v-model="search" placeholder="搜索目录" style="margin-left: 16px;" clearable>
              <template #prefix>
                <el-icon class="el-input__icon"><ElIcons name="search" /></el-icon>
              </template>
            </el-input>
          </div>
          <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
        </div>
        <div class="content-table">
          <el-table
              ref="multipleTableRef"
              :data="pageDataList.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()) || (data.children && data.children.find(info => info.name.toLowerCase().includes(search.toLowerCase())))  )"
              style="width: 100%; padding-bottom: 12px;"
              v-loading="loading"
              row-key="id"
              @row-click="toggleRowExpansion"
          >
            <el-table-column prop="" label="" width="24"></el-table-column>
            <el-table-column prop="name" label="" width="28">
              <template #default="scope">
                <div v-if="scope.row.level == 1">
                  <div v-if="scope.row.children && scope.row.children.length > 0">
                    <ElIcons v-if="scope.row.css" :name="scope.row.css" />
                    <ElIcons v-else name="FolderAdd" />
                  </div>
                  <div v-else>
                    <ElIcons v-if="scope.row.css" :name="scope.row.css" />
                    <ElIcons v-else name="Document" />
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="目录" v-if="checkColList.indexOf('目录') > -1"></el-table-column>
            <el-table-column prop="" label="操作" v-if="checkColList.indexOf('操作') > -1">
              <template #default="scope">
                <el-button @click="update(scope.row)" type="text">编辑</el-button>
                <el-button @click="del(scope.row)" type="text">删除</el-button>
                <el-button v-if="scope.row.level == 1" @click="append(scope.row)" type="text">添加</el-button>
              </template>
            </el-table-column>
<!--            <el-table-column prop="id" label="id"></el-table-column>-->
            <el-table-column prop="orderNum" label="排序" v-if="checkColList.indexOf('排序') > -1"></el-table-column>
            <el-table-column prop="url" label="url" v-if="checkColList.indexOf('url') > -1"></el-table-column>
          </el-table>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { getFormData, postFormData, deleteFormData } from "@/api/api";
import { menuListAll, delMenuList } from "@/api/url";
import SysModelDialog from "./components/SysModelDialog";
import Dialog from "@/assets/js/dialog"
// import BtnGroup from "@/components/BtnGroup";

export default {
  name: "SysModel",
  components: { },
  data() {
    return {
      sysList: [],
      pageDataList: [],
      loading: false,
      //刷新组
      colList: ['目录', '操作', '排序', 'url'],
      checkColList: [],
      search: '',
    }
  },
  methods: {
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },

    toggleRowExpansion(row, column, event) {
      if(column.label != '操作') {
        this.$refs.multipleTableRef.toggleRowExpansion(row)
      }
    },

    getPage() {
      this.loading = true
      getFormData(menuListAll).then((data)=>{
        let {msg, code} = data
        if (code == 200) {
          this.sysList = data.data;
          this.pageDataList = this.formatList(this.sysList, 0);
          console.log(this.pageDataList)
        }else {
          this.$message({
            message: msg,
            type: 'warning',
            duration: 1000,
          })
        }
        this.loading = false
      }).catch((err) => {
        this.loading = false
        this.$message({
          message: err.msg,
          type: 'warning',
          duration: 1000
        })
      })
    },

    /**
     * 格式化权限
     */
    formatList(list, preId) {
      let array = [];
      let _this = this;
      list.forEach(function(e) {
        if(e['preId'] == preId) {
          let children = _this.formatList(list, e['id']);
          if(children.length > 0) {
            e['children'] = children;
          }
          array.push(e);
        }
      });
      // console.log(array)
      return array;
    },

    /**
     * @author Dave
     * @description 添加权限
     */
    append(data) {
      let title = "添加"+(data.level+1)+"级模块";
      this.callDialog(title, { preId: data.id, level: data.level+1 }, {id: 0});
    },

    update(data) {
      let sysForm = Object.assign({}, data);
      let title = "编辑"+data.level+"级模块";
      this.callDialog(title, sysForm, data);
    },

    callDialog(title, sysForm, data) {
      Dialog.open({
        title: title,
        component: SysModelDialog,
        data: {
          sysForm: sysForm,
          index: data.id,
          width: '500px',
          routes: this.$router.options.routes
        },
        confirm: (result) => {
          if(data.id > 0){
            data.name = result.name;
            data.url = result.url;
            data.css = result.css;
            data.orderNum = result.orderNum;
          } else(
              this.getPage()
          )
        }
      })
    },

    del(data) {
      let _this = this;
      this.$confirm('确认删除【'+data.name+'】？', {
        type: 'warning'
      }).then(
          () => {
            deleteFormData(delMenuList, { id: data.id }).then (
                (result) => {
                  let code = result.code;
                  let msg = result.msg;
                  if(code == 200) {
                    this.getPage();
                  } else {
                    _this.$message({
                      showClose: true,
                      duration: 1000,
                      message: msg,
                      type: 'warning'
                    })
                  }
                }
            )
          }
      ).catch(() => {})
    }



  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>
.el-table {
  --el-table-header-bg-color: #ffffff !important;
}



</style>
